// Font Awesome Free icons (https://fontawesome.com/license/free)
import { faDiscord } from '@fortawesome/free-brands-svg-icons/faDiscord'
import { faCalendarXmark } from '@fortawesome/free-regular-svg-icons/faCalendarXmark'
import { faClock } from '@fortawesome/free-regular-svg-icons/faClock'
import { faClone } from '@fortawesome/free-regular-svg-icons/faClone'
import { faCopy } from '@fortawesome/free-regular-svg-icons/faCopy'
import { faCopyright } from '@fortawesome/free-regular-svg-icons/faCopyright'
import { faKeyboard } from '@fortawesome/free-regular-svg-icons/faKeyboard'
import { faLightbulb } from '@fortawesome/free-regular-svg-icons/faLightbulb'
import { faSquare } from '@fortawesome/free-regular-svg-icons/faSquare'
import { faSquareCheck } from '@fortawesome/free-regular-svg-icons/faSquareCheck'
import { faStar } from '@fortawesome/free-regular-svg-icons/faStar'
import { faTrashCan } from '@fortawesome/free-regular-svg-icons/faTrashCan'
import { faAnglesDown } from '@fortawesome/free-solid-svg-icons/faAnglesDown'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import { faArrowRightArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowRightArrowLeft'
import { faAt } from '@fortawesome/free-solid-svg-icons/faAt'
import { faBarsStaggered } from '@fortawesome/free-solid-svg-icons/faBarsStaggered'
import { faBasketShopping } from '@fortawesome/free-solid-svg-icons/faBasketShopping'
import { faBolt } from '@fortawesome/free-solid-svg-icons/faBolt'
import { faBone } from '@fortawesome/free-solid-svg-icons/faBone'
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook'
import { faBoxArchive } from '@fortawesome/free-solid-svg-icons/faBoxArchive'
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons/faBoxOpen'
import { faChalkboard } from '@fortawesome/free-solid-svg-icons/faChalkboard'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons/faCircleExclamation'
import { faCircleHalfStroke } from '@fortawesome/free-solid-svg-icons/faCircleHalfStroke'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons/faCircleInfo'
import { faCircleUser } from '@fortawesome/free-solid-svg-icons/faCircleUser'
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons/faCloudArrowDown'
import { faCloudArrowUp } from '@fortawesome/free-solid-svg-icons/faCloudArrowUp'
import { faCode } from '@fortawesome/free-solid-svg-icons/faCode'
import { faCopy as faCopySolid } from '@fortawesome/free-solid-svg-icons/faCopy'
import { faDatabase } from '@fortawesome/free-solid-svg-icons/faDatabase'
import { faDesktop } from '@fortawesome/free-solid-svg-icons/faDesktop'
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload'
import { faDragon } from '@fortawesome/free-solid-svg-icons/faDragon'
import { faDroplet } from '@fortawesome/free-solid-svg-icons/faDroplet'
import { faDungeon } from '@fortawesome/free-solid-svg-icons/faDungeon'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import { faEraser } from '@fortawesome/free-solid-svg-icons/faEraser'
import { faExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation'
import { faExpand } from '@fortawesome/free-solid-svg-icons/faExpand'
import { faEyeLowVision } from '@fortawesome/free-solid-svg-icons/faEyeLowVision'
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash'
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons/faFileExcel'
import { faFileExport } from '@fortawesome/free-solid-svg-icons/faFileExport'
import { faFileImage } from '@fortawesome/free-solid-svg-icons/faFileImage'
import { faFileImport } from '@fortawesome/free-solid-svg-icons/faFileImport'
import { faFileZipper } from '@fortawesome/free-solid-svg-icons/faFileZipper'
import { faFireFlameCurved } from '@fortawesome/free-solid-svg-icons/faFireFlameCurved'
import { faFish } from '@fortawesome/free-solid-svg-icons/faFish'
import { faFlask } from '@fortawesome/free-solid-svg-icons/faFlask'
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons/faFloppyDisk'
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons/faFolderOpen'
import { faFont } from '@fortawesome/free-solid-svg-icons/faFont'
import { faFrog } from '@fortawesome/free-solid-svg-icons/faFrog'
import { faGear } from '@fortawesome/free-solid-svg-icons/faGear'
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe'
import { faHashtag } from '@fortawesome/free-solid-svg-icons/faHashtag'
import { faHatWizard } from '@fortawesome/free-solid-svg-icons/faHatWizard'
import { faHeading } from '@fortawesome/free-solid-svg-icons/faHeading'
import { faHeartCrack } from '@fortawesome/free-solid-svg-icons/faHeartCrack'
import { faHeartPulse } from '@fortawesome/free-solid-svg-icons/faHeartPulse'
import { faHorse } from '@fortawesome/free-solid-svg-icons/faHorse'
import { faLanguage } from '@fortawesome/free-solid-svg-icons/faLanguage'
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink'
import { faLinkSlash } from '@fortawesome/free-solid-svg-icons/faLinkSlash'
import { faListCheck } from '@fortawesome/free-solid-svg-icons/faListCheck'
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlass'
import { faMessage } from '@fortawesome/free-solid-svg-icons/faMessage'
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus'
import { faMoon } from '@fortawesome/free-solid-svg-icons/faMoon'
import { faMusic } from '@fortawesome/free-solid-svg-icons/faMusic'
import { faPaste } from '@fortawesome/free-solid-svg-icons/faPaste'
import { faPaw } from '@fortawesome/free-solid-svg-icons/faPaw'
import { faPen } from '@fortawesome/free-solid-svg-icons/faPen'
import { faPencil } from '@fortawesome/free-solid-svg-icons/faPencil'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons/faPenToSquare'
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion'
import { faRecycle } from '@fortawesome/free-solid-svg-icons/faRecycle'
import { faReply } from '@fortawesome/free-solid-svg-icons/faReply'
import { faRightToBracket } from '@fortawesome/free-solid-svg-icons/faRightToBracket'
import { faRotate } from '@fortawesome/free-solid-svg-icons/faRotate'
import { faRotateLeft } from '@fortawesome/free-solid-svg-icons/faRotateLeft'
import { faSatelliteDish } from '@fortawesome/free-solid-svg-icons/faSatelliteDish'
import { faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons/faScrewdriverWrench'
import { faShareNodes } from '@fortawesome/free-solid-svg-icons/faShareNodes'
import { faShield } from '@fortawesome/free-solid-svg-icons/faShield'
import { faShieldHalved } from '@fortawesome/free-solid-svg-icons/faShieldHalved'
import { faSkullCrossbones } from '@fortawesome/free-solid-svg-icons/faSkullCrossbones'
import { faSortDown } from '@fortawesome/free-solid-svg-icons/faSortDown'
import { faSortUp } from '@fortawesome/free-solid-svg-icons/faSortUp'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons/faStar'
import { faStopwatch } from '@fortawesome/free-solid-svg-icons/faStopwatch'
import { faSun } from '@fortawesome/free-solid-svg-icons/faSun'
import { faTable } from '@fortawesome/free-solid-svg-icons/faTable'
import { faTableCells } from '@fortawesome/free-solid-svg-icons/faTableCells'
import { faTags } from '@fortawesome/free-solid-svg-icons/faTags'
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons/faThumbsUp'
import { faThumbtack } from '@fortawesome/free-solid-svg-icons/faThumbtack'
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash'
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons/faTriangleExclamation'
import { faTrophy } from '@fortawesome/free-solid-svg-icons/faTrophy'
import { faUpload } from '@fortawesome/free-solid-svg-icons/faUpload'
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser'
import { faUserLock } from '@fortawesome/free-solid-svg-icons/faUserLock'
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers'
import { faWallet } from '@fortawesome/free-solid-svg-icons/faWallet'
import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons/faWandMagicSparkles'
import { faWrench } from '@fortawesome/free-solid-svg-icons/faWrench'
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark'

export const ICONS = {
  'angles-down': faAnglesDown,
  'arrow-left': faArrowLeft,
  'arrow-right-arrow-left': faArrowRightArrowLeft,
  at: faAt,
  'bars-staggered': faBarsStaggered,
  'basket-shopping': faBasketShopping,
  bolt: faBolt,
  bone: faBone,
  book: faBook,
  'box-archive': faBoxArchive,
  'box-open': faBoxOpen,
  'calendar-xmark': faCalendarXmark,
  chalkboard: faChalkboard,
  check: faCheck,
  'chevron-down': faChevronDown,
  'circle-check': faCircleCheck,
  'circle-exclamation': faCircleExclamation,
  'circle-half-stroke': faCircleHalfStroke,
  'circle-info': faCircleInfo,
  'circle-user': faCircleUser,
  clock: faClock,
  clone: faClone,
  'cloud-arrow-down': faCloudArrowDown,
  'cloud-arrow-up': faCloudArrowUp,
  code: faCode,
  copy: faCopy,
  'copy-solid': faCopySolid,
  copyright: faCopyright,
  database: faDatabase,
  desktop: faDesktop,
  discord: faDiscord,
  download: faDownload,
  dragon: faDragon,
  droplet: faDroplet,
  dungeon: faDungeon,
  envelope: faEnvelope,
  eraser: faEraser,
  exclamation: faExclamation,
  expand: faExpand,
  'eye-low-vision': faEyeLowVision,
  'eye-slash': faEyeSlash,
  file: faFile,
  'file-excel': faFileExcel,
  'file-export': faFileExport,
  'file-image': faFileImage,
  'file-import': faFileImport,
  'file-zipper': faFileZipper,
  'fire-flame-curved': faFireFlameCurved,
  fish: faFish,
  flask: faFlask,
  'floppy-disk': faFloppyDisk,
  'folder-open': faFolderOpen,
  font: faFont,
  frog: faFrog,
  gear: faGear,
  globe: faGlobe,
  hashtag: faHashtag,
  'hat-wizard': faHatWizard,
  heading: faHeading,
  'heart-crack': faHeartCrack,
  'heart-pulse': faHeartPulse,
  horse: faHorse,
  keyboard: faKeyboard,
  language: faLanguage,
  lightbulb: faLightbulb,
  link: faLink,
  'link-slash': faLinkSlash,
  'list-check': faListCheck,
  lock: faLock,
  'magnifying-glass': faMagnifyingGlass,
  message: faMessage,
  minus: faMinus,
  moon: faMoon,
  music: faMusic,
  paste: faPaste,
  paw: faPaw,
  pen: faPen,
  pencil: faPencil,
  'pen-to-square': faPenToSquare,
  play: faPlay,
  plus: faPlus,
  question: faQuestion,
  recycle: faRecycle,
  reply: faReply,
  'right-to-bracket': faRightToBracket,
  rotate: faRotate,
  'rotate-left': faRotateLeft,
  'satellite-dish': faSatelliteDish,
  'screwdriver-wrench': faScrewdriverWrench,
  'share-nodes': faShareNodes,
  shield: faShield,
  'shield-halved': faShieldHalved,
  'skull-crossbones': faSkullCrossbones,
  'sort-down': faSortDown,
  'sort-up': faSortUp,
  spinner: faSpinner,
  square: faSquare,
  'square-check': faSquareCheck,
  star: faStar,
  'star-solid': faStarSolid,
  stopwatch: faStopwatch,
  sun: faSun,
  table: faTable,
  'table-cells': faTableCells,
  tags: faTags,
  'thumbs-up': faThumbsUp,
  thumbtack: faThumbtack,
  trash: faTrash,
  'trash-can': faTrashCan,
  'triangle-exclamation': faTriangleExclamation,
  trophy: faTrophy,
  upload: faUpload,
  user: faUser,
  'user-lock': faUserLock,
  users: faUsers,
  wallet: faWallet,
  'wand-magic-sparkles': faWandMagicSparkles,
  wrench: faWrench,
  xmark: faXmark
}

export type IconName = keyof typeof ICONS

export function isIconName(value: string): value is IconName {
  return Object.hasOwn(ICONS, value)
}
